console.log("custom.js started");
var achievedSlider = new Swiper(".achieved-slider", {
    speed: 800,
    grabCursor: true,
    loop: true,
    navigation: {
        nextEl: ".achieved-next",
        prevEl: ".achieved-prev",
    },
});




var generalServices = new Swiper(".general-slider", {
    speed: 800,
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
        576: {
            spaceBetween: 30,
            slidesPerView: "auto",
        },
        992: {
            spaceBetween: 60,
            slidesPerView: "auto",
        }
    },

    navigation: {
        nextEl: ".services-next",
        prevEl: ".services-prev",
    },
});





let studentsSliderInstance = null;

function toggleSlider() {
    if (window.innerWidth <= 991) {
        if (!studentsSliderInstance) {
            studentsSliderInstance = new Swiper(".students-slider", {
                speed: 800,
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 20,
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    }
                },
                navigation: {
                    nextEl: ".students-next",
                    prevEl: ".students-prev",
                },
            });
        }
    } else {
        if (studentsSliderInstance) {
            studentsSliderInstance.destroy(true, true);
            studentsSliderInstance = null;
        }
    }
}

toggleSlider();
window.addEventListener("resize", toggleSlider);



var reviewSlider = new Swiper(".review-slider", {
  speed: 800,
  grabCursor: true,
  spaceBetween: 20,
 slidesPerView: 1,
  breakpoints: {
    992: {
      slidesPerView: "auto",
    },
    768: {
      slidesPerView: 2,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".review-next",
    prevEl: ".review-prev",
  },
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  //   pauseOnMouseEnter: true,
  // },
});

$(window).on("load", function () {
  $(".review-carousel").carouselTicker({
    speed: 3,
  });

  $(".review-bottom-carousel").carouselTicker({
    speed: 3,
    direction: "next",
  });
});


// Fancy Box Start
// Fancybox.bind("[data-fancybox]", {});
Fancybox.bind("[data-fancybox]", {
		Thumbs: {
			showOnStart: false,
		},
		Toolbar: {
			display: {
			right: ["close"],
			},
		},
	});
// Fancy Box End

console.log("Before AOS");
AOS.init({
    once: true
});
console.log("After AOS");



  const allVideoWrappers = document.querySelectorAll(".video-wrapper");

allVideoWrappers.forEach((wrapper) => {
  const video = wrapper.querySelector("video");
  const btn = wrapper.querySelector(".play-btn");
  const playIcon = btn.querySelector(".icon-play");
  const pauseIcon = btn.querySelector(".icon-pause");

  btn.addEventListener("click", function () {
    const isPlaying = btn.dataset.state === "pause";

    // pause current
    if (isPlaying) {
      video.pause();
      btn.dataset.state = "play";
      playIcon.style.display = "block";
      pauseIcon.style.display = "none";
      return;
    }

    // pause others
    document.querySelectorAll(".video-wrapper video").forEach((v) => {
      if (v !== video) {
        v.pause();
        const otherBtn = v.closest(".video-wrapper").querySelector(".play-btn");
        const otherPlay = otherBtn.querySelector(".icon-play");
        const otherPause = otherBtn.querySelector(".icon-pause");
        otherBtn.dataset.state = "play";
        otherPlay.style.display = "block";
        otherPause.style.display = "none";
      }
    });

    // play this
    video.play();
    btn.dataset.state = "pause";
    playIcon.style.display = "none";
    pauseIcon.style.display = "block";
  });

  // On end → reset play state
  video.addEventListener("ended", function () {
    btn.dataset.state = "play";
    playIcon.style.display = "block";
    pauseIcon.style.display = "none";
  });
});




// $('.client-works-carousel').slick({
//   dots: false,
//   arrows: false,
//   infinite: true,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   speed: 1000,
//   dots: false,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//       }
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         slidesToShow: 1,
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });

